import { Heart } from "lucide-react";
import { FormInput, RadioGroup, CheckboxGroup } from "./FormInput";

const SELLING_REASONS = [
  'Inherited Property', 'Tired Landlord', 'Behind on Payments', 
  'Pre-Foreclosure', 'Relocating', 'Divorce', 
  'Vacant Property', 'Problem Tenants', 'Downsizing', 
  'Financial Hardship', 'Major Repairs Needed', 'Other'
];

const TIMELINE_OPTIONS = [
  'ASAP', 'Within 30 Days', '1-3 Months', '3-6 Months', 'Just Exploring Options'
];

const AGENT_OPTIONS = ['Yes', 'No'];

const OFFER_PREFERENCES = [
  'Cash Offer', 'Seller Financing', 'Subject-To Existing Mortgage', 
  'Lease Option', 'Open to Offers'
];

const SellerMotivationStep = ({ formData, onChange, onCheckboxChange }) => {
  return (
    <div className="space-y-6 animate-fade-in" data-testid="seller-motivation-step">
      <h2 className="text-xl font-bold text-white flex items-center gap-2">
        <Heart className="w-5 h-5 text-[#D4AF37]" />
        Seller Motivation
      </h2>
      
      <div className="space-y-4">
        <CheckboxGroup
          label="Why are you considering selling? (Select all that apply)"
          name="selling_reasons"
          options={SELLING_REASONS}
          selected={formData.selling_reasons}
          onChange={onCheckboxChange}
          required
          columns={3}
        />

        <div>
          <label className="block text-sm text-[#A3A3A3] mb-3">
            How soon are you looking to sell? *
          </label>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-2">
            {TIMELINE_OPTIONS.map((time) => (
              <label 
                key={time}
                className={`flex items-center justify-center p-3 border cursor-pointer transition-all ${
                  formData.timeline === time 
                    ? 'border-[#D4AF37] bg-[#D4AF37]/10 text-[#D4AF37]' 
                    : 'border-white/10 text-[#A3A3A3] hover:border-white/30'
                }`}
              >
                <input
                  type="radio"
                  name="timeline"
                  value={time}
                  checked={formData.timeline === time}
                  onChange={onChange}
                  className="sr-only"
                />
                <span className="text-xs sm:text-sm text-center">{time}</span>
              </label>
            ))}
          </div>
        </div>

        <RadioGroup
          label="Is the property currently listed with a real estate agent?"
          name="listed_with_agent"
          options={AGENT_OPTIONS}
          value={formData.listed_with_agent}
          onChange={onChange}
          required
        />

        <div>
          <label className="block text-sm text-[#A3A3A3] mb-2">
            What is your asking price? *
          </label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-[#666]">$</span>
            <input
              type="text"
              name="asking_price"
              value={formData.asking_price}
              onChange={onChange}
              placeholder="Enter amount or 'Make an offer'"
              className="w-full input-dark pl-8 pr-4 py-4"
            />
          </div>
        </div>

        <CheckboxGroup
          label="Would you consider: (Select all that apply)"
          name="offer_preferences"
          options={OFFER_PREFERENCES}
          selected={formData.offer_preferences}
          onChange={onCheckboxChange}
          required
          columns={3}
        />
      </div>
    </div>
  );
};

export default SellerMotivationStep;
